export default __webpack_public_path__ + "static/media/superb.c1603890.png";